module.exports = __webpack_public_path__ + "static/media/18.238cf33e.jpg";